import axios from 'axios'

const API_BASE_URL = window.env.REACT_APP_DEMO_BACKEND_URL
let cachedConfig = null
let configPromise = null

// Set up axios interceptor to add domain header to all requests
// This ensures the header is present before any API calls are made
axios.interceptors.request.use(function (config) {
    const domain = window.location.hostname
    config.headers['domain'] = domain
    return config
})

export const retrieveConfig = async () => {
    // Return cached config if available
    if (cachedConfig) {
        return cachedConfig
    }

    // Return existing promise if a request is already in flight
    // This prevents duplicate requests when multiple components mount simultaneously
    if (configPromise) {
        return configPromise
    }

    const hostName = window.location.hostname

    // Store the promise to prevent duplicate requests
    configPromise = axios
        .post(API_BASE_URL + '/config', {
            domain: hostName,
        })
        .then(response => {
            cachedConfig = response.data
            configPromise = null // Clear the promise after successful completion
            return cachedConfig
        })
        .catch(error => {
            configPromise = null // Clear the promise on error to allow retry
            console.error(`Error retrieving config: ${error}`)
            throw error
        })

    return configPromise
}

export const getConfig = async () => {
    const config = await retrieveConfig()

    return config
}

const SENTRY_ENV_MAP = [
    ['.dev.in.ecomm.dmginternal.net', 'dev'],
    ['.dev.vn.ecomm.dmginternal.net', 'dev-vn'],
    ['.dev.th.ecomm.dmginternal.net', 'dev-th'],
    ['.stg.vn.ecomm.dmgnet.io', 'stg-vn'],
    ['.stg.th.ecomm.dmgnet.io', 'stg-th'],
    ['.vn.ecomm.dmgnet.io', 'prod-vn'],
    ['.th.ecomm.dmgnet.io', 'prod-th'],
]

export function getSentryEnvKey() {
    const hostname = window.location.hostname
    return SENTRY_ENV_MAP.find(([pattern]) => hostname.includes(pattern))?.[1] ?? 'local'
}
